export const siteStats = [
  { label: "收录作品", value: "3,280+", unit: "部", icon: "ri-stack-line" },
  { label: "本周新更", value: "148", unit: "部", icon: "ri-refresh-line" },
  { label: "字幕类型", value: "简繁双语", unit: "", icon: "ri-translate-2" },
  { label: "高清占比", value: "92", unit: "%", icon: "ri-hd-line" },
];

export const navLinks = [
  { id: "ranking", label: "热门排行" },
  { id: "picks", label: "编辑精选" },
  { id: "browse", label: "分类浏览" },
  { id: "collections", label: "最新合集" },
  { id: "guide", label: "观看指引" },
  { id: "faq", label: "常见问题" },
];

export const heroFeatured = [
  {
    title: "晚风信箱",
    meta: "日剧 · 治愈 · 2024",
    rating: "9.4",
    icon: "ri-mail-open-line",
    note: "本周口碑上升最快",
  },
  {
    title: "雾中信号",
    meta: "韩剧 · 悬疑 · 2024",
    rating: "9.2",
    icon: "ri-radar-line",
    note: "悬疑讨论度第一",
  },
  {
    title: "第七次日落",
    meta: "日影 · 爱情 · 2024",
    rating: "9.0",
    icon: "ri-sun-line",
    note: "编辑本月首推",
  },
  {
    title: "首尔夜行列车",
    meta: "韩剧 · 都市 · 2023",
    rating: "8.9",
    icon: "ri-train-line",
    note: "都市群像佳作",
  },
];

export const rankings = [
  {
    rank: 1,
    title: "晚风信箱",
    region: "日剧",
    genres: ["治愈", "剧情"],
    year: "2024",
    rating: 9.4,
    reviews: "2.1 万",
    reason:
      "慢节奏治愈叙事，中文台词翻译自然口语化，旁白与内心独白处理干净，适合夜晚安静地看。",
    tags: ["高分", "治愈系", "适合下饭"],
  },
  {
    rank: 2,
    title: "雾中信号",
    region: "韩剧",
    genres: ["悬疑", "犯罪"],
    year: "2024",
    rating: 9.2,
    reviews: "1.8 万",
    reason:
      "多线叙事层层递进，时间线字幕标注清晰，事件与人物关系不会因为跨语言而看不明白。",
    tags: ["烧脑", "反转多", "需专注"],
  },
  {
    rank: 3,
    title: "昼与夜之界",
    region: "韩影",
    genres: ["剧情"],
    year: "2023",
    rating: 9.1,
    reviews: "1.5 万",
    reason:
      "剧本结构扎实，长镜头对白较多，字幕断句与情绪节奏贴合，适合喜欢细品的观众。",
    tags: ["电影节系", "群像"],
  },
  {
    rank: 4,
    title: "第七次日落",
    region: "日影",
    genres: ["爱情", "剧情"],
    year: "2024",
    rating: 9.0,
    reviews: "1.3 万",
    reason:
      "画面与配乐出彩，双语字幕对照方便学日语，日常对话部分用词地道、生活感强。",
    tags: ["画面美", "双语字幕"],
  },
  {
    rank: 5,
    title: "首尔夜行列车",
    region: "韩剧",
    genres: ["都市", "群像"],
    year: "2023",
    rating: 8.9,
    reviews: "1.1 万",
    reason:
      "以末班车串联不同乘客的短篇故事，一集一单元的节奏，字幕对地域与俚语做了简单注释。",
    tags: ["单元剧", "通勤可看"],
  },
  {
    rank: 6,
    title: "海边的图书馆",
    region: "日剧",
    genres: ["家庭", "治愈"],
    year: "2022",
    rating: 8.8,
    reviews: "9,600",
    reason:
      "家庭题材温情细腻，长辈口音台词的意译处理自然，不会读起来别扭，适合全家一起看。",
    tags: ["温情", "长镜头"],
  },
  {
    rank: 7,
    title: "无声的证词",
    region: "韩影",
    genres: ["犯罪", "剧情"],
    year: "2024",
    rating: 8.7,
    reviews: "8,200",
    reason:
      "法庭与审讯戏份密集，专业术语配有简明说明，快速台词也能跟上，紧张感不被打断。",
    tags: ["法庭戏", "快节奏"],
  },
  {
    rank: 8,
    title: "京都四季帖",
    region: "日影",
    genres: ["纪录", "人文"],
    year: "2023",
    rating: 8.6,
    reviews: "7,400",
    reason:
      "纪录片式拍摄，旁白字幕干净克制，涉及节气与手工艺的专有名词做了对照注释。",
    tags: ["纪录", "涨知识"],
  },
];

export const editorPicks = [
  {
    title: "晚风信箱",
    region: "日剧",
    year: "2024",
    rating: "9.4",
    tags: ["治愈", "书信"],
    desc: "邮局职员替人转交旧信，串起小镇上几段错过的缘分。文字温柔，字幕保留了原句的含蓄。",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20poster%20art%20of%20a%20quiet%20wooden%20letter%20box%20beside%20a%20sunlit%20window%20at%20dusk%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20uncluttered%20background%2C%20soft%20film%20grain%2C%20editorial%20mood%2C%20gentle%20shadows%2C%20harmonious%20warm%20palette&width=600&height=840&seq=subs-poster-01&orientation=portrait",
  },
  {
    title: "雾中信号",
    region: "韩剧",
    year: "2024",
    rating: "9.2",
    tags: ["悬疑", "推理"],
    desc: "一名记者调查十年前的旧案，随着线索浮出水面，身边每个人都变得可疑。适合喜欢边看边记线索的人。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20art%20of%20a%20misty%20sepi%20toned%20alley%20with%20a%20single%20glowing%20lamp%20and%20faint%20fog%20in%20the%20air%2C%20warm%20brown%20and%20gold%20tones%2C%20simple%20clean%20background%2C%20soft%20grain%2C%20mysterious%20editorial%20atmosphere%2C%20subtle%20shadows&width=600&height=840&seq=subs-poster-02&orientation=portrait",
  },
  {
    title: "第七次日落",
    region: "日影",
    year: "2024",
    rating: "9.0",
    tags: ["爱情", "青春"],
    desc: "两个在夏天打工的年轻人约好一起看七场日落。画面与配乐都很出彩，双语字幕方便对照学习。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20poster%20art%20of%20two%20distant%20silhouettes%20watching%20a%20golden%20sunset%20over%20a%20calm%20sea%2C%20amber%20orange%20and%20peach%20tones%2C%20minimal%20uncluttered%20background%2C%20soft%20film%20grain%2C%20romantic%20editorial%20mood%2C%20gentle%20glow&width=600&height=840&seq=subs-poster-03&orientation=portrait",
  },
  {
    title: "昼与夜之界",
    region: "韩影",
    year: "2023",
    rating: "9.1",
    tags: ["剧情", "群像"],
    desc: "一栋老楼里几家住户的日常，因一场停电而产生交集。长镜头对白多，字幕断句克制而准确。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20an%20old%20apartment%20interior%20split%20between%20warm%20daylight%20and%20deep%20shadow%2C%20earthy%20amber%20and%20terracotta%20tones%2C%20minimal%20uncluttered%20background%2C%20soft%20film%20grain%2C%20thoughtful%20editorial%20mood&width=600&height=840&seq=subs-poster-04&orientation=portrait",
  },
  {
    title: "京都四季帖",
    region: "日影",
    year: "2023",
    rating: "8.6",
    tags: ["纪录", "人文"],
    desc: "跟随镜头走过京都的一年四季，记录节气、手作与日常。涉及专有名词的地方都做了对照注释。",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20cinematic%20poster%20art%20of%20a%20classic%20japanese%20garden%20in%20warm%20seasonal%20autumn%20light%2C%20soft%20amber%20and%20moss%20green%20tones%2C%20minimal%20uncluttered%20background%2C%20gentle%20film%20grain%2C%20calm%20documentary%20editorial%20mood&width=600&height=840&seq=subs-poster-05&orientation=portrait",
  },
  {
    title: "首尔夜行列车",
    region: "韩剧",
    year: "2023",
    rating: "8.9",
    tags: ["都市", "单元剧"],
    desc: "以城市末班车为舞台，一集讲一位乘客的故事。字幕对方言与流行语附了简短说明，通勤时看正合适。",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20poster%20art%20of%20a%20night%20train%20window%20with%20warm%20passing%20lights%20and%20soft%20reflections%2C%20amber%20and%20deep%20brown%20tones%2C%20minimal%20uncluttered%20background%2C%20soft%20film%20grain%2C%20urban%20editorial%20mood&width=600&height=840&seq=subs-poster-06&orientation=portrait",
  },
];

export const browseCategories = ["全部", "日剧", "韩剧", "日影", "韩影", "动画", "综艺"];

export const browseItems = [
  { title: "晚风信箱", category: "日剧", year: "2024", rating: "9.4", note: "治愈书信题材，台词翻译自然", tags: ["治愈"] },
  { title: "雾中信号", category: "韩剧", year: "2024", rating: "9.2", note: "多线悬疑，时间线标注清晰", tags: ["悬疑"] },
  { title: "昼与夜之界", category: "韩影", year: "2023", rating: "9.1", note: "群像长片，对白节奏贴合", tags: ["剧情"] },
  { title: "第七次日落", category: "日影", year: "2024", rating: "9.0", note: "双语字幕，适合日语学习", tags: ["爱情"] },
  { title: "首尔夜行列车", category: "韩剧", year: "2023", rating: "8.9", note: "单元剧结构，通勤可看", tags: ["都市"] },
  { title: "海边的图书馆", category: "日剧", year: "2022", rating: "8.8", note: "家庭温情，意译不别扭", tags: ["家庭"] },
  { title: "无声的证词", category: "韩影", year: "2024", rating: "8.7", note: "法庭戏密集，术语带注释", tags: ["犯罪"] },
  { title: "京都四季帖", category: "日影", year: "2023", rating: "8.6", note: "节气与手作专名对照", tags: ["纪录"] },
  { title: "银河慢递局", category: "动画", year: "2024", rating: "9.3", note: "剧场版，字幕干净不遮挡画面", tags: ["番剧"] },
  { title: "放学后的料理室", category: "动画", year: "2023", rating: "8.9", note: "日常番，食材名词附注", tags: ["治愈"] },
  { title: "深夜食堂手记", category: "综艺", year: "2024", rating: "8.4", note: "纪实类，旁白字幕克制", tags: ["纪实"] },
  { title: "街头乐队的夏天", category: "综艺", year: "2023", rating: "8.3", note: "音乐竞演，歌词双语呈现", tags: ["音乐"] },
  { title: "侦探事务所的午后", category: "日剧", year: "2024", rating: "8.5", note: "轻推理，台词轻松诙谐", tags: ["推理"] },
  { title: "汉江边的约定", category: "韩剧", year: "2022", rating: "8.7", note: "都市情感，情绪对白到位", tags: ["爱情"] },
  { title: "春之海物语", category: "日影", year: "2023", rating: "8.8", note: "渔村题材，方言意译自然", tags: ["剧情"] },
  { title: "四季之家", category: "韩剧", year: "2024", rating: "8.6", note: "家庭群像，长辈台词贴心", tags: ["家庭"] },
];

export const collections = [
  {
    title: "2024 秋季档新番合集",
    count: "28 部",
    desc: "本季更新中的日韩剧与动画一次性收齐，按更新日排列，随时回来补最新进度。",
    tags: ["正在更新", "追新必看"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20banner%20of%20a%20warm%20autumn%20street%20with%20golden%20leaves%20and%20soft%20afternoon%20window%20light%2C%20amber%20and%20cream%20tones%2C%20minimalist%20uncluttered%20composition%2C%20soft%20film%20grain%2C%20cozy%20seasonal%20mood&width=800&height=520&seq=subs-coll-01&orientation=landscape",
  },
  {
    title: "高分悬疑推理合集",
    count: "19 部",
    desc: "时间线复杂、反转多的作品集中在此，字幕组对关键情节做了必要提示，看不懂的地方能回查。",
    tags: ["烧脑", "反转多"],
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20banner%20of%20a%20foggy%20old%20library%20with%20warm%20lamp%20light%20and%20dust%20motes%2C%20sepia%20and%20amber%20tones%2C%20minimalist%20uncluttered%20composition%2C%20soft%20grain%2C%20mysterious%20atmosphere&width=800&height=520&seq=subs-coll-02&orientation=landscape",
  },
  {
    title: "治愈系日常精选",
    count: "35 部",
    desc: "节奏舒缓、适合放松心情的日常向作品合集，台词生活化，翻译口语自然，失眠时看也不压力。",
    tags: ["舒缓", "下饭"],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20banner%20of%20a%20cozy%20sunlit%20kitchen%20with%20steaming%20teacup%20and%20soft%20linen%20textures%2C%20peach%20and%20cream%20tones%2C%20minimalist%20uncluttered%20composition%2C%20gentle%20film%20grain%2C%20calm%20mood&width=800&height=520&seq=subs-coll-03&orientation=landscape",
  },
  {
    title: "日韩电影获奖合集",
    count: "24 部",
    desc: "电影节与口碑奖项里出现的作品收录于此，长短片皆有，字幕倾向于保留原片语感。",
    tags: ["电影节", "长篇"],
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20editorial%20banner%20of%20an%20empty%20vintage%20movie%20theater%20with%20warm%20amber%20seats%20and%20soft%20projector%20glow%2C%20gold%20and%20brown%20tones%2C%20minimalist%20uncluttered%20composition%2C%20soft%20grain&width=800&height=520&seq=subs-coll-04&orientation=landscape",
  },
  {
    title: "古装历史大盘点",
    count: "17 部",
    desc: "涉及历史背景与官职称谓的作品，字幕对专有名词做了注释，看得懂也看得进故事。",
    tags: ["古装", "附注释"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20banner%20of%20a%20traditional%20east%20asian%20courtyard%20with%20warm%20lantern%20light%20and%20wooden%20architecture%2C%20terracotta%20and%20gold%20tones%2C%20minimalist%20uncluttered%20composition%2C%20soft%20film%20grain&width=800&height=520&seq=subs-coll-05&orientation=landscape",
  },
  {
    title: "动画剧场版精选",
    count: "22 部",
    desc: "画面细节丰富的剧场版，字幕位置经过调整不遮挡关键画面，歌词部分采用双语对照呈现。",
    tags: ["剧场版", "画面控"],
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20editorial%20banner%20of%20a%20starry%20night%20sky%20above%20warm%20glowing%20city%20rooftops%2C%20amber%20and%20muted%20rose%20tones%2C%20minimalist%20uncluttered%20composition%2C%20soft%20film%20grain%2C%20whimsical%20mood&width=800&height=520&seq=subs-coll-06&orientation=landscape",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "按榜单定位作品",
    desc: "先从热门排行或编辑精选入手，看到感兴趣的作品名称后，滚动到分类浏览区，用标签快速筛出同类。",
    icon: "ri-list-ordered",
  },
  {
    step: "02",
    title: "确认字幕版本",
    desc: "同一部作品常有简体、繁体与双语版本。先看清字幕类型说明，学习用途优先选双语，观看体验优先选单语。",
    icon: "ri-translate-2",
  },
  {
    step: "03",
    title: "选择观看或下载",
    desc: "在线观看适合随时打开，下载则适合网络不稳或想反复回看的场景。建议优先选择标注清晰的来源再保存。",
    icon: "ri-download-2-line",
  },
  {
    step: "04",
    title: "收藏与追更",
    desc: "正在更新的作品会有进度标记，配合本页的更新订阅，能第一时间知道新一集或新字幕是否已经上线。",
    icon: "ri-bookmark-3-line",
  },
];

export const viewingTips = [
  {
    icon: "ri-hd-line",
    title: "优先高清片源",
    desc: "高清版本在文字边缘更清晰，长时间阅读字幕不容易疲劳，小字号双语的差别尤其明显。",
  },
  {
    icon: "ri-stack-line",
    title: "认准字幕版本",
    desc: "同一作品的简繁、双语、注释版本更新节奏不同，切换前先确认版本号，避免进度对不上。",
  },
  {
    icon: "ri-wifi-line",
    title: "弱网先下载",
    desc: "通勤或网络不稳定时，提前下载好片源与字幕文件，观看过程会更顺畅不卡顿。",
  },
  {
    icon: "ri-sound-module-line",
    title: "外挂字幕更灵活",
    desc: "需要调整字号、位置或时轴时，外挂字幕文件比内嵌版本更好处理，适合有进一步需求的观众。",
  },
];

export const faqs = [
  {
    q: "站内这些合集是怎么整理的？",
    a: "合集按题材、地区与口碑综合归类，按目前热度和更新状态排序，目的是帮你在片荒的时候快速挑选，而不是逐一罗列全部条目。",
  },
  {
    q: "简体、繁体和双语字幕应该怎么选？",
    a: "习惯阅读简体就选简体，港澳台地区用户可优先繁体；如果带有语言学习目的，双语版本能同时看到原文与译文，更有帮助。",
  },
  {
    q: "怎样在片荒时快速找到合适的作品？",
    a: "建议按顺序来：先看热门排行，再用分类浏览的标签筛出偏好题材，最后看编辑精选里的介绍文字，一般三五分钟就能选出想看的。",
  },
  {
    q: "为什么同一作品会有多个字幕版本？",
    a: "不同字幕组对翻译风格、注释详细程度与更新时间的选择不同，有的偏口语自然，有的偏精准注释，按自己的观看习惯取舍即可。",
  },
  {
    q: "排行榜的分数代表什么？",
    a: "分数是站内根据观看完成度、收藏与讨论热度综合形成的参考值，仅供选片时参考，并不代表唯一的评价标准。",
  },
  {
    q: "更新是多久一次？",
    a: "热门作品一般随更新节奏同步维护，合集类内容通常每周整理一次；订阅更新通知后，新合集上线会第一时间收到提醒。",
  },
];